var queryString = queryString || {};

queryString.stringify = function (json) {
    var aggregator = { string: "" };

    recurse(aggregator, json, "");
    return aggregator.string;
};

function isObject(obj) {
    return (typeof obj === "object" && obj !== null) || typeof obj === "function";
}

function recurse(aggregator, node, path) {
    if (node == null) {
        // do nothing
    } else if (typeof node.getMonth === 'function') {
        if (aggregator.string.length > 0) {
            aggregator.string += "&";
        }
        aggregator.string += path + "=" + node.toISOString();
    } else if (Array.isArray(node)) {
        for (var key in node) {
            recurse(aggregator, node[key], path);
        }
    } else if (isObject(node)) {
        for (var key in node) {
            var newPath = key;
            if (path.length > 0) {
                var newPath = path + "." + key;
            }
            if (node.hasOwnProperty(key)) {
                recurse(aggregator, node[key], newPath);
            }
        }
    } else if (isObject(node)) {
        for (var key in node) {
            var newPath = key;
            if (path.length > 0) {
                var newPath = path + "." + key;
            }
            recurse(aggregator, node[key], newPath)
        }
    } else {
        if (aggregator.string.length > 0) {
            aggregator.string += "&";
        }
        aggregator.string += path + "=" + encodeURIComponent(node.toString());
    }
}


if (typeof module != "undefined") {
    module.exports = queryString;
}
